
<div style="padding-top: 0px;" class="row" id="rowdiv" >
<embed  type="application/pdf" src="" width="100%" height="100%" id="embed">
</div>

<div style="padding-top: 0px;" class="row" id="pdfjs" >
    <ng2-pdfjs-viewer #pdfViewerAutoLoad></ng2-pdfjs-viewer>
    </div>